VLW.Video = class extends VLW.classBase {
	constructor(elt) {
		super(elt);
		let optionsVimeo = {
			id   : 275991890,
			width: "100%",
			loop : true
		};
		this.player      = new Vimeo.Player('vimeo-player', optionsVimeo);
		this.player.setVolume(0);
		this.close = this.elt.querySelector("._close");
		this.close.addEventListener("click",this.onClickClose);
	}
	onClickClose(e){
		this.hide();
	}
	hide(){
		TweenMax.to(this.elt,.75,{opacity:0,pointerEvents:"none",display:"none"});
		this.player.pause();
	}
	display(){
		TweenMax.set(this.elt,{clearProps:"display"});
		TweenMax.to(this.elt,.75,{opacity:1,pointerEvents:"auto",display:"flex"});
		this.player.play();
	}
	
	instanceClean() {
	}
};
if (document.querySelector("#vimeo-player")) {
	window.SITE_VIDEO = new VLW.Video(document.querySelector("#vimeo-player"));
}